import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const API = 'https://cotizaciones-fabrica-rivera-production.up.railway.app/api';
const BASE = 'https://cotizaciones-fabrica-rivera-production.up.railway.app';

const imgSrc = (url) => {
  if (!url) return null;
  return url.startsWith('http') ? url : `${BASE}${url}`;
};

const ESTADOS = [
  { key: 'borrador',      label: 'Borrador',      color: '#888' },
  { key: 'enviada',       label: 'Enviada',        color: '#2196F3' },
  { key: 'en_aprobacion', label: 'En aprobación',  color: '#FF9800' },
  { key: 'aprobada',      label: 'Aprobada',       color: '#4CAF50' },
  { key: 'rechazada',     label: 'Rechazada',      color: '#f44336' },
  { key: 'ganada',        label: 'Ganada',         color: '#8BC34A' },
  { key: 'perdida',       label: 'Perdida',        color: '#9E9E9E' },
];

export default function VerCotizacion() {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const esCliente = usuario?.rol === 'cliente';
  const [cot, setCot] = useState(null);

  useEffect(() => {
    axios.get(`${API}/cotizaciones/${id}`, { headers }).then(r => setCot(r.data));
  }, [id]);

  const cambiarEstado = async (nuevoEstado) => {
    try {
      if (nuevoEstado === 'aprobada' || nuevoEstado === 'rechazada') {
        const comentario = window.prompt(`Comentario para "${nuevoEstado}" (opcional):`);
        await axios.put(`${API}/cotizaciones/${id}/aprobar`,
          { decision: nuevoEstado, comentario },
          { headers }
        );
      } else {
        await axios.put(`${API}/cotizaciones/${id}/estado`,
          { estado: nuevoEstado },
          { headers }
        );
      }
      window.location.reload();
    } catch (err) {
      alert('Error: ' + (err.response?.data?.error || err.message));
    }
  };

  if (!cot) return <div style={{ padding: '2rem' }}>Cargando...</div>;

  const notas = cot.notas || '';
  const formaPago = notas.match(/FORMA DE PAGO: (.+)/)?.[1] || 'CONTADO';
  const tiempoEntrega = notas.match(/TIEMPO DE ENTREGA: (.+)/)?.[1] || '';
  const notasLimpias = notas.replace(/FORMA DE PAGO:.+\n?/, '').replace(/TIEMPO DE ENTREGA:.+\n?/, '').replace(/ASESOR:.+\n?/, '').trim();
  const estadoActual = cot.estado || 'borrador';
  const asesor = notas.match(/ASESOR: (.+)/)?.[1] || 'Geyson Rivera';
  const estadoInfo = ESTADOS.find(e => e.key === estadoActual);
  const incluyeIva = cot.incluye_iva !== false;
  const mostrarColumnaIva = cot.tipo_cotizacion !== 'AIU' && incluyeIva;

  return (
    <div>
      {/* BARRA DE ACCIONES */}
      <div style={s.acciones} className="no-print">
        {esCliente ? (
          <button style={s.btnVolver} onClick={() => window.location.href='https://lafabricadrivera.com'}>← Volver a la Tienda</button>
        ) : (
          <button style={s.btnVolver} onClick={() => window.location.href='/'}>← Volver</button>
        )}
        {!esCliente && (
          <button style={s.btnEditar} onClick={() => window.location.href=`/cotizacion/${id}/editar`}>✏️ Editar</button>
        )}
        <button style={s.btnImprimir} onClick={() => window.print()}>Imprimir / PDF</button>
      </div>

      {/* BARRA DE ESTADOS — solo para internos */}
      {!esCliente && (
        <div style={s.estadoBar} className="no-print">
          {ESTADOS.map(e => (
            <button
              key={e.key}
              style={{
                ...s.estadoBtn,
                background: estadoActual === e.key ? e.color : 'transparent',
                color:      estadoActual === e.key ? '#fff' : e.color,
                border:     `1px solid ${e.color}`,
                fontWeight: estadoActual === e.key ? '700' : '400',
                cursor:     estadoActual === e.key ? 'default' : 'pointer',
              }}
              onClick={() => estadoActual !== e.key && cambiarEstado(e.key)}
            >
              {e.label}
            </button>
          ))}
        </div>
      )}

      {/* ESTADO VISIBLE PARA CLIENTES */}
      {esCliente && (
        <div style={s.estadoClienteBar} className="no-print">
          <span style={s.estadoClienteLabel}>Estado:</span>
          <span style={{
            background: estadoInfo?.color || '#888',
            color: '#fff',
            padding: '6px 16px',
            borderRadius: '20px',
            fontWeight: '700',
            fontSize: '13px'
          }}>
            {estadoInfo?.label || estadoActual}
          </span>
        </div>
      )}

      {!esCliente && cot.aprobacion?.comentario && (
        <div style={s.comentarioAprobacion} className="no-print">
          💬 <strong>{cot.estado === 'aprobada' ? 'Aprobado' : 'Rechazado'}:</strong> {cot.aprobacion.comentario}
        </div>
      )}

      <div style={s.pagina} id="cotizacion-print" className="rf-ver-pagina">
        <div style={s.encabezado} className="rf-ver-encabezado">
          <div style={s.encDatos}>
            <p style={s.empresa}>LA FÁBRICA D' RIVERA S.A.S</p>
            <p style={s.encLinea}>NIT. 901 585 523 - 9</p>
            <p style={s.encLinea}>RÉGIMEN DE TRIBUTACIÓN SIMPLE - RST</p>
            <p style={s.encLinea}>CARTAGENA - BOLÍVAR</p>
            <p style={s.encLinea}>BR SAN JOSE DE LOS CAMPANOS CRA 100#38-A02</p>
            <p style={s.encLinea}>CONTACTO. 3012788104 - 3135618419</p>
            <p style={s.encLinea}>EMAIL. lafabricadrivera@gmail.com</p>
            <p style={s.encLinea}>@lafabricadrivera</p>
          </div>
          <div style={s.encCot}>
            <p style={s.cotLabel}>COTIZACIÓN</p>
            <p style={s.encLinea}>No. {cot.numero}</p>
            <p style={s.encLinea}>FECHA: {new Date(cot.created_at).toLocaleDateString('es-CO')}</p>
          </div>
          <div style={s.encLogo} className="contenedor-logo-impresion">
            <img src="/Logo lafdr.png" alt="Logo La Fábrica D'Rivera" style={{ width:'160px', height:'160px', objectFit:'contain' }} />
          </div>
        </div>

        <div style={{ ...s.separador, position: 'relative' }}>
          <span style={{
            position: 'absolute', right: 0, top: '-10px',
            background: '#1a1a2e', color: '#c8a951',
            padding: '2px 12px', borderRadius: '4px',
            fontSize: '11px', fontWeight: '700', letterSpacing: '0.05em',
          }}>
            {cot.tipo_cotizacion === 'AIU' ? 'COTIZACIÓN LAFDR-AIU' : 'COTIZACIÓN LAFDR'}
          </span>
        </div>

        <div style={s.clienteBloque} className="rf-ver-cliente">
          <div style={s.clienteIzq}>
            <p style={s.clienteLinea}><strong>CLIENTE:</strong> {cot.razon_social}</p>
            <p style={s.clienteLinea}><strong>{cot.tipo_documento || 'NIT'}:</strong> {cot.nit}</p>
            <p style={s.clienteLinea}><strong>DIR.</strong> {cot.ciudad}</p>
            <p style={s.clienteLinea}><strong>CONTACTO:</strong> {[cot.cliente_telefono, cot.contacto].filter(Boolean).join(' - ')}</p>
            <p style={s.clienteLinea}><strong>Email.</strong> {cot.cliente_email || ''}</p>
          </div>
          <div style={s.clienteDer}>
            <p style={s.clienteLinea}><strong>FORMA DE PAGO:</strong> {formaPago}</p>
            <p style={s.clienteLinea}><strong>VALIDEZ DE LA OFERTA HASTA:</strong> {cot.fecha_vencimiento ? new Date(cot.fecha_vencimiento).toLocaleDateString('es-CO') : ''}</p>
            <p style={s.clienteLinea}><strong>TIEMPO DE ENTREGA:</strong> {tiempoEntrega}</p>
            <p style={s.clienteLinea}><strong>ASESOR COMERCIAL:</strong> {asesor}</p>
            <p style={s.clienteLinea}><strong>Email.</strong> lafabricadrivera@gmail.com</p>
          </div>
        </div>

        <div style={s.frase}>
          Gracias por elegirnos, para LA FÁBRICA D' RIVERA S.A.S es importante atender su solicitud, por tal motivo cotizamos a continuación:
        </div>

        <div className="rf-tabla-wrap">
        <table style={{...s.tabla, minWidth:'700px'}}>
          <thead>
           <tr style={s.theadRow}>
                <th style={{...s.th, width:'5%'}}>ÍTEM</th>
                <th style={{...s.th, width: mostrarColumnaIva ? '13%' : '15%'}}>ARTÍCULO</th>
                <th style={{...s.th, width: mostrarColumnaIva ? '28%' : '32%'}}>CARACTERÍSTICAS</th>
                <th style={{...s.th, width:'6%'}}>CANTD</th>
                <th style={{...s.th, width: mostrarColumnaIva ? '12%' : '14%'}}>VR UNITARIO</th>
                {mostrarColumnaIva && <th style={{...s.th, width:'10%'}}>IVA 19%</th>}
                <th style={{...s.th, width: mostrarColumnaIva ? '12%' : '13%'}}>SUBTOTAL</th>
                <th style={{...s.th, width:'14%'}}>IMAGEN REF.</th>
              </tr>
          </thead>
          <tbody>
            {cot.items.map((item, i) => {
              const desc = item.descripcion_libre || '';
              const partes = desc.split(' - ');
              const nombre = partes[0] || item.producto_nombre || '';
              const caract = partes.slice(1).join(' - ') || item.producto_descripcion || '';
              const subtotalCalculado = parseFloat(item.subtotal);
              const ivaCalculado = (item.aplica_iva && incluyeIva) ? subtotalCalculado * 0.19 : 0;
              const totalFila = subtotalCalculado + ivaCalculado;
              return (
                <tr key={item.id} style={i % 2 === 0 ? s.rowPar : s.rowImpar}>
                  <td style={s.tdC}>{i + 1}</td>
                  <td style={s.tdB}>{nombre}</td>
                  <td style={{...s.td2, maxWidth:'200px', wordWrap:'break-word'}}>{caract}</td>
                  <td style={s.tdC}>{item.cantidad}</td>
                  <td style={s.tdR}>$ {Math.round(item.precio_unitario).toLocaleString('es-CO')}</td>
                  {mostrarColumnaIva && (
                  <td style={s.tdR}>$ {Math.round(ivaCalculado).toLocaleString('es-CO')}</td>
                  )}
                  <td style={s.tdR}>$ {Math.round(subtotalCalculado).toLocaleString('es-CO')}</td>
                  <td style={s.tdC}>
                    {item.imagen_url
                      ? <img src={imgSrc(item.imagen_url)} alt={nombre} style={s.itemImg} />
                      : <div style={s.sinImg}>—</div>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>

        <div style={s.totalesBloque} className="rf-ver-totales">
          <div style={s.totalesIzq}>
            {notasLimpias && (
              <>
                <p style={s.obsLabel}>OBSERVACIONES:</p>
                <p style={s.obsTexto}>{notasLimpias}</p>
              </>
            )}
          </div>
          <div style={s.totalesDer}>
  <div style={s.totalFila}>
    <span>{cot.tipo_cotizacion === 'AIU' ? 'COSTO DIRECTO' : 'SUBTOTAL'}</span>
    <span>$ {Math.round(cot.subtotal).toLocaleString('es-CO')}</span>
  </div>

  {cot.tipo_cotizacion === 'AIU' ? (
    <>
      <div style={s.totalFila}>
        <span>ADMINISTRACIÓN ({cot.porcentaje_administracion}%)</span>
        <span>$ {Math.round(cot.valor_administracion).toLocaleString('es-CO')}</span>
      </div>
      <div style={s.totalFila}>
        <span>IMPREVISTOS ({cot.porcentaje_imprevistos}%)</span>
        <span>$ {Math.round(cot.valor_imprevistos).toLocaleString('es-CO')}</span>
      </div>
      <div style={s.totalFila}>
        <span>UTILIDAD ({cot.porcentaje_utilidad}%)</span>
        <span>$ {Math.round(cot.valor_utilidad).toLocaleString('es-CO')}</span>
      </div>
      <div style={{ ...s.totalFila, fontWeight: '700', borderBottom: '2px solid #c8a951' }}>
        <span>AIU TOTAL</span>
        <span>$ {Math.round(cot.valor_aiu).toLocaleString('es-CO')}</span>
      </div>
      <div style={s.totalFila}>
        <span>IVA 19% (sobre Utilidad)</span>
        <span>{incluyeIva ? `$ ${Math.round(cot.iva).toLocaleString('es-CO')}` : 'No Aplica'}</span>
      </div>
    </>
  ) : (
    <>
      <div style={s.totalFila}><span>IVA</span><span>{incluyeIva ? `$ ${Math.round(cot.iva).toLocaleString('es-CO')}` : 'No Aplica'}</span></div>
      <div style={s.totalFila}><span>% DEL IVA</span><span>{incluyeIva ? '19%' : '0% (Exento)'}</span></div>
    </>
  )}

  <div style={s.totalNeto}>
    <span>TOTAL NETO FACTURA</span>
    <span>$ {Math.round(cot.total).toLocaleString('es-CO')}</span>
  </div>
</div>
        </div>

        <div style={s.pie}>
          {cot.condiciones && (
            <p style={s.condiciones}><strong>CONDICIONES GENERALES DE VENTA:</strong> {cot.condiciones}</p>
          )}
          <p style={s.banco}><strong>BANCO: DAVIVIENDA cuenta de ahorros 058200219465</strong> a nombre de LA FÁBRICA D' RIVERA S.A.S</p>
          <p style={s.banco}>Por favor enviar el soporte de pago por correo electrónico para el respectivo despacho.</p>
          <br />
          <p style={s.banco}>Cordialmente,</p>
          <p style={s.firmaEmpresa}>LA FÁBRICA D'RIVERA SAS</p>
        </div>
      </div>

      <style>{`
        @media print {
          @page { size: A4 portrait; margin: 10mm; }
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; }
          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          #cotizacion-print { box-shadow: none !important; margin: 0 !important; padding: 8mm !important; max-width: 100% !important; width: 100% !important; font-size: 9px !important; }
          .rf-tabla-wrap { overflow: visible !important; width: 100% !important; }
          table { width: 100% !important; min-width: 0 !important; max-width: 100% !important; table-layout: fixed !important; border-collapse: collapse !important; font-size: 8px !important; }
          th, td { word-wrap: break-word !important; overflow-wrap: break-word !important; padding: 4px 3px !important; }
          thead tr { background-color: #1a1a2e !important; }
          thead tr th { color: #c8a951 !important; }
          thead { display: table-header-group !important; }
          tr, td, th { page-break-inside: avoid !important; break-inside: avoid !important; }
          table img { width: 42px !important; height: 42px !important; object-fit: cover !important; page-break-inside: avoid !important; }
          .contenedor-logo-impresion img { width: 150px !important; height: 150px !important; object-fit: contain !important; }
        }
      `}</style>
    </div>
  );
}

const s = {
  acciones:            { padding:'1rem 2rem', background:'#1a1a2e', display:'flex', gap:'12px', flexWrap:'wrap' },
  btnVolver:           { background:'transparent', color:'#aaa', border:'1px solid #aaa', padding:'8px 14px', borderRadius:'8px', cursor:'pointer' },
  btnEditar:           { background:'#1a1a2e', color:'#c8a951', border:'1px solid #c8a951', padding:'8px 18px', borderRadius:'8px', fontWeight:'700', cursor:'pointer' },
  btnImprimir:         { background:'#c8a951', color:'#fff', border:'none', padding:'8px 18px', borderRadius:'8px', fontWeight:'700', cursor:'pointer' },
  estadoBar:           { display:'flex', gap:'8px', flexWrap:'wrap', padding:'10px 2rem', background:'#111827' },
  estadoBtn:           { padding:'6px 14px', borderRadius:'20px', fontSize:'13px', transition:'all 0.2s' },
  estadoClienteBar:    { display:'flex', gap:'12px', alignItems:'center', padding:'10px 2rem', background:'#111827' },
  estadoClienteLabel:  { color:'#aaa', fontSize:'13px' },
  comentarioAprobacion:{ background:'#fff3cd', color:'#856404', padding:'10px 2rem', fontSize:'13px', borderBottom:'1px solid #ffeeba' },
  pagina:              { maxWidth:'960px', margin:'1rem auto', background:'#fff', padding:'2rem', boxShadow:'0 2px 12px rgba(0,0,0,0.1)', fontSize:'12px' },
  encabezado:          { display:'grid', gridTemplateColumns:'1fr 1fr 180px', gap:'1rem', marginBottom:'1rem' },
  encDatos:            {},
  empresa:             { fontWeight:'700', fontSize:'14px', marginBottom:'4px' },
  encLinea:            { margin:'2px 0', fontSize:'11px' },
  encCot:              {},
  cotLabel:            { fontWeight:'700', fontSize:'16px', marginBottom:'6px' },
  encLogo:             { display:'flex', justifyContent:'center' },
  separador:           { height:'2px', background:'#c8a951', margin:'1rem 0' },
  clienteBloque:       { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem', background:'#f9f9f9', padding:'1rem', marginBottom:'1rem', border:'1px solid #ddd' },
  clienteIzq:          {},
  clienteDer:          {},
  clienteLinea:        { margin:'3px 0', fontSize:'11px' },
  frase:               { background:'#f0f0f0', padding:'8px 12px', fontSize:'11px', marginBottom:'1rem', fontStyle:'italic' },
  tabla:               { width:'100%', borderCollapse:'collapse', marginBottom:'1rem' },
  theadRow:            { background:'#1a1a2e' },
  th:                  { padding:'8px 6px', color:'#c8a951', textAlign:'center', fontWeight:'700', fontSize:'10px', border:'1px solid #333' },
  rowPar:              { background:'#fff' },
  rowImpar:            { background:'#f9f9f9' },
  tdC:                 { padding:'6px', textAlign:'center', border:'1px solid #ddd', fontSize:'11px', verticalAlign:'middle' },
  tdB:                 { padding:'6px', textAlign:'center', border:'1px solid #ddd', fontSize:'11px', fontWeight:'700', width:'120px' },
  td2:                 { padding:'6px', border:'1px solid #ddd', fontSize:'11px' },
  tdR:                 { padding:'6px', textAlign:'right', border:'1px solid #ddd', fontSize:'11px' },
  itemImg:             { width:'60px', height:'60px', objectFit:'cover', borderRadius:'4px' },
  sinImg:              { width:'60px', height:'60px', display:'flex', alignItems:'center', justifyContent:'center', color:'#ccc', fontSize:'16px' },
  totalesBloque:       { display:'grid', gridTemplateColumns:'1fr 280px', gap:'1rem', marginBottom:'1rem' },
  totalesIzq:          {},
  totalesDer:          { border:'1px solid #ddd' },
  obsLabel:            { fontWeight:'700', fontSize:'11px', marginBottom:'4px' },
  obsTexto:            { fontSize:'11px', lineHeight:'1.5' },
  totalFila:           { display:'flex', justifyContent:'space-between', padding:'6px 10px', borderBottom:'1px solid #eee', fontSize:'12px' },
  totalNeto:           { display:'flex', justifyContent:'space-between', padding:'10px', background:'#c8a951', color:'#fff', fontWeight:'700', fontSize:'14px' },
  pie:                 { borderTop:'1px solid #ddd', paddingTop:'1rem' },
  condiciones:         { fontSize:'10px', marginBottom:'8px', lineHeight:'1.5' },
  banco:               { fontSize:'11px', margin:'3px 0' },
  firmaEmpresa:        { fontWeight:'700', fontSize:'13px', marginTop:'4px' },
};